import React from 'react'
import HeadingNew from 'presentation/shared/components/HeadingNew'
import ResponsiveModal from 'presentation/shared/components/ResponsiveModal'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import { ReactComponent as MaintenanceIllustration } from 'presentation/assets/illustrations/maintenance-illustration.svg'
import * as S from './styles'

export type MaintenanceNoticeResponsiveModalProps = {
  isOpen: boolean
  onClose: () => void
}

const MaintenanceNoticeResponsiveModal = ({
  isOpen,
  onClose
}: MaintenanceNoticeResponsiveModalProps) => (
  <ResponsiveModal
    isOpen={isOpen}
    title="Aviso Importante"
    onClose={onClose}
    hideCancelButton
    hideConfirmButton
    width={500}
  >
    {(isMobile) => (
      <S.Content>
        <HeadingNew
          size={isMobile ? 'medium' : 'large'}
          color="textPrimary"
          weight="bold"
          fontFamily="secondary"
          style={{ lineHeight: 1.3 }}
        >
          Todos os serviços digitais do Meu Mater Dei estarão indisponíveis.
        </HeadingNew>

        <S.Illustration>
          <MaintenanceIllustration />
        </S.Illustration>

        <SupportTextNew
          color="textSecondary"
          fontFamily="secondary"
          style={{ lineHeight: 1.4 }}
        >
          Entre os dias <b>14 e 16 de agosto</b>, todos os serviços estarão
          indisponíveis devido uma manutenção programada.
        </SupportTextNew>

        <S.InfoCard>
          <HeadingNew
            size="xsmall"
            color="info950"
            weight="bold"
            style={{ lineHeight: 1.4 }}
          >
            Atendimento presencial continuará funcionando normalmente.
          </HeadingNew>
          <SupportTextNew
            size="xsmall"
            color="textPrimary"
            fontFamily="secondary"
            style={{ lineHeight: 1.5 }}
          >
            Caso necessite realizar consultas, exames ou atendimento médico,
            especialmente em situações de urgência e emergência, procure
            diretamente uma de nossas unidades.
          </SupportTextNew>
        </S.InfoCard>
      </S.Content>
    )}
  </ResponsiveModal>
)

export default MaintenanceNoticeResponsiveModal
